import { Phone, Mail, MessageSquareText } from "lucide-react";
import { CONTACT } from "@/lib/api";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy noise-overlay relative pt-20 pb-10 border-t-4 border-tpink">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid md:grid-cols-2 gap-12 items-start">
        <div>
          <div className="flex items-center gap-4">
            <img src={CONTACT.logo} alt="The Plumbing & Electrical Co. logo" className="w-20 h-20 object-contain bg-white rounded-full p-1" />
            <div>
              <p className="font-bebas text-2xl text-white leading-tight">LEAK-DETECTION<span className="text-brand">.COM.AU</span></p>
              <p className="text-xs text-white/50 font-semibold tracking-widest">BY THE PLUMBING & ELECTRICAL CO.</p>
            </div>
          </div>
          <p className="mt-6 text-sm text-white/50 max-w-xs">
            Perth's leak detectives. Upfront prices. Live slots. Lifetime labour.
          </p>
        </div>
        <div>
          <p className="font-bebas text-xl text-brand tracking-wide mb-5">TALK TO A HUMAN</p>
          <div className="space-y-3">
            <a data-testid="footer-phone-link" href={CONTACT.phoneHref} className="flex items-center gap-3 text-white/80 hover:text-brand transition-colors duration-200">
              <Phone className="w-4 h-4 text-brand" /> {CONTACT.phone}
            </a>
            <a data-testid="footer-text-link" href={CONTACT.textHref} className="flex items-center gap-3 text-white/80 hover:text-brand transition-colors duration-200">
              <MessageSquareText className="w-4 h-4 text-brand" /> Text {CONTACT.text}
            </a>
            <a data-testid="footer-email-link" href={CONTACT.emailHref} className="flex items-center gap-3 text-white/80 hover:text-brand transition-colors duration-200">
              <Mail className="w-4 h-4 text-brand" /> {CONTACT.email}
            </a>
          </div>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p data-testid="footer-licenses" className="text-xs text-white/40 font-semibold tracking-widest">{CONTACT.licenses}</p>
        <p className="text-xs text-white/40">© {new Date().getFullYear()} The Plumbing & Electrical Co. All work to AS/NZS 3500:2021. Prices include GST.</p>
      </div>
    </div>
  </footer>
);
